var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"opacity"}},[_c('dir',{staticClass:"xt-pagination"},[_c('a-pagination',{attrs:{"hideOnSinglePage":"","current":_vm.Pagination.current,"total":_vm.Pagination.total,"pageSize":_vm.Pagination.pageSize,"item-render":_vm.itemRender},on:{"change":_vm.onCurrentChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }